<template>
  <div class="bc500-charts">
    <template v-for="(config, index) in options">
      <ChartItem
        v-bind="config"
        :key="index"
        :color="colors[index % 3]"
        :serie-style="serieStyles[index % 3]"
      ></ChartItem>
    </template>
  </div>
</template>

<script>
import ChartItem from './chart-item.vue';
import { serieStyles, colors } from '@/utils/deviceDict/bc500';

export default {
  components: {
    ChartItem
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    serieStyles() {
      return serieStyles;
    },
    colors() {
      return colors;
    }
  }
};
</script>

<style lang="scss">
.bc500-charts {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .bc500-chart {
    width: 32%;
    height: calc(50% - var(--charts-gap) / 2);
  }
}
</style>
